const STORAGE_KEY = 'rentroy-saved-analyses';

export function getSavedAnalyses() {
    try {
        const data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : [];
    } catch {
        return [];
    }
}

export function getSavedAnalysisById(id) {
    return getSavedAnalyses().find((a) => a.id === id) || null;
}

export function saveAnalysis({name, inputs, additionalPayments, lumpSumPayments, result, replaceId = null}) {
    let analyses = getSavedAnalyses();
    const lastMonth = result.milestoneSnapShots[result.milestoneSnapShots.length - 1];
    const entry = {
        id: replaceId || Date.now().toString(36) + Math.random().toString(36).slice(2, 6),
        name,
        savedAt: new Date().toISOString(),
        inputs,
        additionalPayments,
        lumpSumPayments,
        summary: {
            purchasePrice: result.purchasePrice,
            cumulativeCashFlow: lastMonth.cumulativeCashFlow,
            pointOfPositiveCashFlow: result.pointOfPositiveCashFlow,
            pointOfPositiveCumulativeCashFlow: result.pointOfPositiveCumulativeCashFlow,
            lastMonth: lastMonth.month,
        },
    };
    if (replaceId) {
        analyses = analyses.filter((a) => a.id !== replaceId);
    }
    analyses.unshift(entry);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(analyses));
    return entry;
}

export function touchSavedAnalysis(id) {
    const analyses = getSavedAnalyses();
    const index = analyses.findIndex((a) => a.id === id);
    if (index > 0) {
        const [entry] = analyses.splice(index, 1);
        analyses.unshift(entry);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(analyses));
    }
}

export function deleteSavedAnalysis(id) {
    const analyses = getSavedAnalyses().filter((a) => a.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(analyses));
}
